<!--
 * @FileDescription: Sku信息展示Two
 * @Author: 陈文景
 * @Date: 2022-11-07 14:39:49
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="sku-info">
    <div class="info">
      <div class="top f-b-c">
        <div class="f">
          <div class="sku-code">
            <span class="code">SKU: {{ defaultTips(data.skuCode) }}</span>
            <!-- 配件信息(暂时不做) -->
            <el-popover v-if="false" placement="bottom-start" :append-to-body="false" :visible-arrow="true" width="366" trigger="hover">
              <div class="content">
                <h3 class="title">{{ $t('Order.Sales.Details.Web.Components.SkuInfoItemTwo.CustomizedService') }}</h3>
                <div v-for="item in 2" :key="item" class="list">
                  <img src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" alt="img.png" />
                  <p class="info">
                    <span class="describe">{{ $t('Order.Sales.Details.Web.Components.SkuInfoItemTwo.Tips1') }}</span>
                    <span class="sum">x 4</span>
                  </p>
                </div>
              </div>
              <span slot="reference" class="icon">
                <i class="el-icon-price-tag" />
              </span>
            </el-popover>
          </div>
          <div v-if="data.platformCode !== 'KA'">{{ $t('Order.Sales.Details.Web.Components.SkuInfoItemTwo.StoreSKU') }}: {{ defaultTips(data.sellerSku) }}</div>
        </div>
        <div>
          {{ data.countryName }}
        </div>
      </div>

      <div class="bottom">
        <div class="img-info">
          <img :src="data.imageUrl" alt="img.png" />
          <div class="info-item">
            <p class="title">{{ defaultTips(data.productName) }}</p>
            <p class="size">{{ defaultTips(data.options) }}</p>
          </div>
        </div>
        <div class="refund-info">
          <p>
            <span class="lable">{{ $t('Order.Sales.Details.Web.Components.SkuInfoItemTwo.QTY') }}:</span>
            <span class="value">{{ amountTips(data.productNum) }}</span>
          </p>
          <p>
            <span class="lable">{{ $t('Order.Sales.Details.Web.Components.SkuInfoItemTwo.RefundAmount') }}:</span>
            <span class="value">${{ amountTips(data.stateRefundAmount) }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  computed: {
    amountTips() {
      return (value) => value || 0
    },
    defaultTips() {
      return (value) => value || '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-info {
  padding: 15px 0;
  border-bottom: 1px solid #f5f7f7;
  .info {
    flex: 1;
    .top {
      color: #747a87;
      font-size: 13px;
      margin-bottom: 10px;
      .sku-code {
        position: relative;
        margin-right: 32px;
        .content {
          .title {
            margin-bottom: 14px;
          }
          .list {
            display: flex;
            margin-bottom: 14px;
            &:last-child {
              margin-bottom: 0;
            }
            img {
              width: 53px;
              height: 53px;
              margin-right: 14px;
              border-radius: 6px;
            }
            .info {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .describe {
                color: #10141d;
              }
              .sum {
                color: #10141d;
              }
            }
          }
        }
        .icon {
          position: absolute;
          top: 0;
          right: -22px;
          width: 18px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          background: rgba(153, 196, 28, 0.06);
          border-radius: 2px;
          user-select: none;
          cursor: pointer;
          i {
            color: #99c41c;
            transform: rotate(328deg);
          }
        }
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      .img-info {
        display: flex;
        height: 100%;
        img {
          width: 70px;
          height: 72px;
          object-fit: cover;
          border-radius: 4px;
        }
        .info-item {
          display: flex;
          color: #10141d;
          font-size: 14px;
          font-weight: 400;
          margin-left: 10px;
          flex-direction: column;
          justify-content: space-between;
          p {
            &:nth-child(1),
            &:nth-child(2),
            &:nth-child(3) {
              margin-bottom: 5px;
            }
          }
          .title {
            display: -webkit-box;
            line-height: 20px;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
      .refund-info {
        display: flex;
        margin-left: 25px;
        flex-direction: column;
        justify-content: flex-end;
        p {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;
          &:nth-child(1) {
            margin-bottom: 5px;
          }
          .lable,
          .value {
            color: #000;
            font-size: 14px;
          }
          .lable {
            display: inline-block;
            width: 138px;
            text-align: end;
          }
          .value {
            color: #f56c6c;
            margin-left: 5px;
          }
        }
      }
    }
  }
}
</style>
